import React from 'react';

const Configure = ({ className }: { className?: string }) => {
	return (
		<svg
			className={className}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 25.642 23.212">
			<path
				d="M25.615,21.4l-.864-3.1a.812.812,0,1,0-1.565.432l.324,1.188-3.86-2.213V11.174a.84.84,0,0,0-.4-.7L13.631,7.234V2.78l.864.891a.823.823,0,0,0,.567.243.928.928,0,0,0,.567-.216.806.806,0,0,0,.027-1.134L13.415.27A.765.765,0,0,0,12.821,0a.735.735,0,0,0-.567.243l-2.24,2.294a.8.8,0,1,0,1.161,1.107l.864-.891V7.207L6.37,10.5a.805.805,0,0,0-.4.7v6.532l-3.86,2.213.351-1.188a.829.829,0,0,0-.567-1,.829.829,0,0,0-1,.567L.027,21.4a.827.827,0,0,0,.081.621.837.837,0,0,0,.486.378l3.131.783a.527.527,0,0,0,.189.027.834.834,0,0,0,.783-.594.8.8,0,0,0-.594-.972l-1.188-.324,3.86-2.213,5.641,3.266a.813.813,0,0,0,.81,0l5.641-3.266,3.86,2.213-1.215.3a.792.792,0,0,0,.189,1.565.459.459,0,0,0,.189-.027l3.158-.756a.763.763,0,0,0,.486-.378.827.827,0,0,0,.081-.621M7.585,12.578l4.427,2.564V20.27L7.558,17.706V12.578Zm5.236,1.161L8.367,11.174,12.821,8.61l4.454,2.564Zm.81,6.532V15.142l4.454-2.564v5.128Z"
				fill="#fff"
			/>
		</svg>
	);
};

export default Configure;
